export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11273.1fea4d76.jpg";